import { BaseEntity } from "./base-entity";

export interface NotificationButton {
  Label: string;
  Action: string;
  Color: string;
  Icon: string;
  BadgeText: string;
  BadgeClass: string;
}


export class UserNotify extends BaseEntity{
    constructor(){
        super();
    };


    UserId: number = null;
    Procitano: boolean = null;
    Poruka: string = null;
    DatumIVremePoruke: Date = null;
    Sadrzaj: string = null
    VremeProcitanaPoruka: Date = null;
    Tip:string = null;
    Parametri: { [key: string]: string } = {};
    Button: NotificationButton[] = [];
    ActionResult: string = null;

Deserialize(input: any) {
    super.Deserialize(input);
    this.ID = input.ID;
    this.UserId = input.UserId;
    this.Procitano = input.Procitano;
    this.Poruka = input.Poruka;
    this.DatumIVremePoruke = input.DatumIVremePoruke;
    this.Sadrzaj = input.Sadrzaj;
    this.VremeProcitanaPoruka = input.VremeProcitanaPoruka;
    this.Tip = input.Tip;
    this.Parametri = input.Parametri
    this.Button = input.Button
    this.ActionResult = input.ActionResult
    return this;
}


    Serialize(input:UserNotify){
        return input;
    }

}